<db-dialog-wrapper [dialog]="this" [width]="'955px'" [height]="'602px'">
  <div class="db-restore-security-issue-dialog">
    <div class="db-restore-security-issue-dialog__info">
      <div class="db-restore-security-issue-dialog__info-item">
        <div>File path</div>
        <div>{{securityIssue.file_path}}</div>
      </div>

      <div class="db-restore-security-issue-dialog__info-item">
        <div>File size</div>
        <div [innerHTML]="securityFileDiff?.fileSize | size"></div>
      </div>

      <div class="db-restore-security-issue-dialog__info-item">
        <div>Date</div>
        <div>{{securityFileDiff?.date | dbDate : 'dd MMM y, HH:mm:ss'}}</div>
      </div>
    </div>

    <div class="db-restore-security-issue-dialog__log db-panel db-panel_flex"
         [ngClass]="{'db-restore-security-issue-dialog__log_cant-preview': !canPreview}">
      <div class="db-panel__body" dbCustomScrollbar *ngIf="canPreview">
        <ng-container *ngIf="securityFileDiff">
          <div class="db-restore-security-issue-dialog__diff">
            <div class="db-restore-security-issue-dialog__diff-row" [ngClass]="{'db-restore-security-issue-dialog__diff-row_added': row.added, 'db-restore-security-issue-dialog__diff-row_removed': row.removed}" *ngFor="let row of securityFileDiff.diff">
              <div><span>{{row.originalLineNumber}}</span></div>
              <div><span>{{row.lineNumber}}</span></div>
              <div></div>
              <div><pre>{{row.content}}</pre></div>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="db-panel__header" *ngIf="!canPreview">
        <div>Preview is not available for this type of files.</div>
      </div>
    </div>

    <div class="db-restore-security-issue-dialog__button">
      <a class="db-button db-button_info sl-restore-issue-file-dialog-restore-button" [ngClass]="{'db-button_disabled': restoring}" (click)="restore()"
         *ngIf="securityIssue.status.toLowerCase() !== 'added'">
        <span *ngIf="!restoring">Restore</span>
        <span class="sl-restore-issue-file-dialog-restore-progress" *ngIf="restoring"><db-loading-circular-spinner></db-loading-circular-spinner></span>
      </a>

      <a class="db-button db-button_danger sl-restore-issue-file-dialog-restore-button" [ngClass]="{'db-button_disabled': restoring}" (click)="restore()"
         *ngIf="securityIssue.status.toLowerCase() === 'added'">
        <span *ngIf="!restoring">Delete</span>
        <span class="sl-restore-issue-file-dialog-restore-progress" *ngIf="restoring"><db-loading-circular-spinner></db-loading-circular-spinner></span>
      </a>
    </div>

    <db-loading-screen *ngIf="loading"></db-loading-screen>
  </div>
</db-dialog-wrapper>
